module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAMAAADEfo0+AAAAAXNSR0IArs4c6QAAAFpQTFRFAAAA/1VV/1VV/21t/2ZN/1VV62JO8VVV81VV7FVM7lVM8VpM7FdR61RN7FRM7VNM7FRM7FRM7FRM61RM7FNL7FNL7FNM61RL7FRM7FRM7FNL7FNL61NM61NLUGFrJgAAAB10Uk5TAAMGBwoMDRIVGx4lKXSJip2krra7vsfM1Njf4+lCDBZ3AAAAZUlEQVQY093NxRWAQAAD0eDuLtN/m8iyD2rg3zKXSEZV6supoXbe7bWcWs/ucOA2hGbHE48pvna6wN5As8OSSvkGa1ZAka2w5epgTnQFJTN0CvoxkgmKxj6QXF82yHft8xNe/wwHEuMMuICRuFgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico/up.png
// module id = GY4E
// module chunks = 1